import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PaymentMethodSelector from '../components/PaymentMethodSelector';
import api from '../utils/api';

const PaymentSelectionPage: React.FC = () => {
  const navigate = useNavigate();
  const [orderNumber, setOrderNumber] = useState<string>('');
  const [orderTotal, setOrderTotal] = useState<string>('');
  const [method, setMethod] = useState<string>('cash_on_delivery');
  const [saving, setSaving] = useState(false);
  const [pendingPayload, setPendingPayload] = useState<any>(null);

  useEffect(() => {
    const payloadRaw = sessionStorage.getItem('pendingOrderPayload');
    const total = sessionStorage.getItem('pendingOrderTotal') || '';
    setOrderTotal(total);

    if (!payloadRaw) {
      navigate('/checkout');
      return;
    }

    try {
      setPendingPayload(JSON.parse(payloadRaw));
    } catch {
      sessionStorage.removeItem('pendingOrderPayload');
      sessionStorage.removeItem('pendingOrderTotal');
      navigate('/checkout');
    }
  }, [navigate]);

  const handleSendOrder = async () => {
    if (!pendingPayload) return;

    try {
      setSaving(true);

      const payload = {
        ...pendingPayload,
        paymentMethod: method
      };

      const { data } = await api.post('/api/orders', payload);
      const createdOrderId = data?.orderId || '';
      const createdOrderNumber = data?.orderNumber || '';

      setOrderNumber(createdOrderNumber);

      // keep last order context (optional for next screens/logging)
      sessionStorage.setItem('lastOrderId', createdOrderId);
      sessionStorage.setItem('lastOrderNumber', createdOrderNumber);
      sessionStorage.setItem('lastOrderTotal', orderTotal);

      // remove pending draft to avoid duplicate submits
      sessionStorage.removeItem('pendingOrderPayload');
      sessionStorage.removeItem('pendingOrderTotal');

      alert(`تم إرسال الطلب بنجاح. رقم الطلب: ${createdOrderNumber}`);
      navigate('/');
    } catch (e) {
      alert('تعذر إرسال الطلب. حاول مرة أخرى.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-dark-bg py-8 transition-colors duration-300" dir="rtl">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white dark:bg-dark-surface rounded-lg shadow-sm border border-gray-200 dark:border-dark-border p-6">
          <div className="flex items-baseline justify-between">
            <h1 className="text-2xl font-bold text-gray-900 dark:text-dark-text mb-2">اختر طريقة الدفع</h1>
            <div className="text-sm text-gray-600 dark:text-dark-textSecondary mb-2">
              رقم الطلب: <span className="font-bold">{orderNumber || '-'}</span>
            </div>
          </div>
          <p className="text-sm text-gray-600 dark:text-dark-textSecondary mb-4">المجموع: ₪{orderTotal}</p>

          <PaymentMethodSelector selectedMethod={method} onMethodChange={setMethod} />

          {method === 'reflect_wallet' && (
            <div className="mt-4 p-4 bg-amber-50 dark:bg-amber-900/20 rounded-lg text-amber-900 dark:text-amber-100">
              ارسل النقود الى محفظة ريفلكت برقم <span className="font-bold">0599554659</span> واكتب رقم الطلب والاسم عند الايداع.
              <div className="mt-2">رقم طلبك: <span className="font-bold">{orderNumber || 'سيظهر بعد الإرسال'}</span></div>
            </div>
          )}

          <div className="mt-6">
            <button
              onClick={handleSendOrder}
              disabled={saving}
              className="w-full btn-primary py-3 text-lg font-semibold disabled:opacity-60"
            >
              {saving ? 'جاري الإرسال...' : 'إرسال الطلب'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSelectionPage;
